<template functional>
	<ul class="page-tabs" :class="{ 'sidebar-collapsed': props.sidebarCollapsed }">
		<slot></slot>
	</ul>
</template>

<script>
export default {
	props: {
		sidebarCollapsed: Boolean
	}
};
</script>

<style lang="scss">
@import '../variables';

.page-tabs {
	position: fixed;
	top: $app-topbar-height + $section-topbar-height;
	left: $app-sidebar-width + $section-sidebar-width;
	right: 0;
	height: $page-tabs-height;
	list-style-type: none;
	margin: 0;
	padding: 0;
	background-color: $lighter-gray;
	z-index: 998;

	&.sidebar-collapsed {
		left: $app-sidebar-collapsed-width + $section-sidebar-width;
	}
}
</style>
